/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/20
 *
 */
import PaymentIntegrationItem from "@shared/Billing/PaymentIntegrationItem";
import PaymentIntegrationType from "@shared/Billing/PaymentIntegrationType";
import Token from "@shared/integrations/OAuthToken";
import {Type} from "class-transformer";


export default class StripeIntegrationItem extends PaymentIntegrationItem {

	stripeEmail: string = null
	stripeUserId: string = null
	stripePublishableKey: string = null

	@Type(() => Token)
	token: Token = null


	constructor() {
		super();
		this.type = PaymentIntegrationType.STRIPE
		this.title = "Stripe"

	}

	paymentMethodFormatted(){
		return "Credit Card (via Stripe)"
	}

}
